import React from "react";
import { formatDateTime } from "./rootDashboardUtils";

export default function RootResetsSection({ pendingResets = [] }) {
  return (
    <div className="management-card root-section-card mb-4" id="root-resets">
      <div className="root-card-header">
        <div>
          <h6 className="root-card-title mb-1">Resets pendientes</h6>
          <small className="text-muted">Solicitudes activas</small>
        </div>
        <span className="management-pill root-chip">
          <i className="bi bi-key" />
          {pendingResets.length}
        </span>
      </div>
      <div className="management-table-wrapper">
        <table className="table management-table mb-0">
          <thead>
            <tr>
              <th>Email</th>
              <th>Creado</th>
              <th>Expira</th>
            </tr>
          </thead>
          <tbody>
            {pendingResets.length ? (
              pendingResets.map((row) => (
                <tr key={row.id}>
                  <td>{row.email}</td>
                  <td>{formatDateTime(row.creado)}</td>
                  <td>{formatDateTime(row.expira)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center text-muted py-3">
                  Sin resets pendientes
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
